const usePermissionConfig = () => {
  return {
    // 发起审批
    FQSP: 'OPS-XMFW-SPGL-FQSP',
    // 编辑审批
    BJSP: 'OPS-XMFW-SPGL-BJSP',
    // 是否公共服务
    GGFW: 'OPS-XMFW-SPGL-GGFW',
    // 是否启用
    QY: 'OPS-XMFW-SPGL-QY',
    // 审批详情
    SPXQ: 'OPS-XMFW-SPGL-SPXQ',
  };
};

export default usePermissionConfig;
